import React, { memo, useEffect } from "react";

const FullMockDetails = memo(function FullMockDetails({
	setCheckPoint, mock, setNextFlag
}) {

	useEffect(() => {
		setNextFlag(true);
		// setCheckPoint(2);
	}, []);

	return (
		<div className="col-xs-12 successContent mock-resource-text">
			<div className="col-lg-12">
				<h4 className="mt-0">Welcome {mock.user_data.first_name} {mock.user_data.last_name}</h4>
				<div className="col-12 d-none d-md-block">
					<table className="table table-bordered">
						<thead>
							<tr>
								<th>Part</th>
								<th>Content</th>
								<th>Time Allowed</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>1</td>
								<td>Speaking & Writing</td>
								<td>{parseInt(mock.mock.speaking_time) + parseInt(mock.mock.writting_time)} minutes</td>
							</tr>
							<tr>
								<td>2</td>
								<td>Reading</td>
								<td>{mock.mock.reading_time} minutes</td>
							</tr>
							{mock.mock.break === 0 ? (
								<tr>	
									<td colSpan={2} className="text-center">Optional scheduled break</td>	
									<td>10 minutes</td>	
								</tr>
							) : ''}
							<tr>
								<td>3</td>
								<td>Listening</td>
								<td>{mock.mock.listening_time} minutes</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div className="col-12 d-block d-md-none">
					<div className="border rounded p-3">

						<div className="mb-3 border-bottom">
						<p className="mb-1"><strong>Part:</strong> 1</p>
						<p className="mb-1"><strong>Content:</strong> Speaking & Writing</p>
						<p className="mb-0">
							<strong>Time Allowed:</strong>{" "}
							{parseInt(mock.mock.speaking_time) +
							parseInt(mock.mock.writting_time)}{" "}
							minutes
						</p>
						</div>

						<div className="mb-3 border-bottom">
						<p className="mb-1"><strong>Part:</strong> 2</p>
						<p className="mb-1"><strong>Content:</strong> Reading</p>
						<p className="mb-0">
							<strong>Time Allowed:</strong> {mock.mock.reading_time} minutes
						</p>
						</div>

						{mock.mock.break === 0 && (
						<div className="mb-3 border-bottom">
							<p className="mb-1"><strong>Break:</strong> Optional scheduled break</p>
							<p className="mb-0"><strong>Duration:</strong> 10 minutes</p>
						</div>
						)}

						<div>
						<p className="mb-1"><strong>Part:</strong> 3</p>
						<p className="mb-1"><strong>Content:</strong> Listening</p>
						<p className="mb-0">
							<strong>Time Allowed:</strong> {mock.mock.listening_time} minutes
						</p>
						</div>

					</div>
				</div>
			</div>
		</div>
	);
});

export default FullMockDetails;